import React, { useMemo } from "react";
import { Sparkles } from "lucide-react";

export const MagicTemplateGallery = ({ templates, showTemplates, setShowTemplates, onSelectTemplate }) => {
  const filteredTemplates = useMemo(() => templates.filter(t => t.thumbnail_b64), [templates]);

  if (!showTemplates || templates.length === 0) return null;

  return (
    <div className="lg:col-span-2 mb-2">
      <div className="flex items-center justify-between mb-3">
        <div>
          <h2 className="text-lg font-bold text-[#1E1B4B] flex items-center gap-2">
            <Sparkles size={18} className="text-[#E83E8C]" /> Decoration Previews
          </h2>
          <p className="text-xs text-[#94a3b8] mt-0.5">Browse our decoration styles — or upload your room for a custom preview</p>
        </div>
        <button onClick={() => setShowTemplates(false)} className="text-xs text-[#94a3b8] hover:text-[#E83E8C] transition-colors">Hide</button>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3">
        {filteredTemplates.map(t => (
          <button
            key={t.template_id}
            onClick={() => onSelectTemplate(t)}
            className="group relative rounded-xl overflow-hidden border-2 border-transparent hover:border-[#E83E8C] transition-all shadow-sm hover:shadow-md"
            data-testid={`template-${t.template_id}`}
          >
            <img
              src={`data:image/jpeg;base64,${t.thumbnail_b64}`}
              alt={`${t.package} ${t.occasion}`}
              className="w-full aspect-[4/3] object-cover group-hover:scale-105 transition-transform duration-300"
              loading="lazy"
            />
            <div className="absolute bottom-0 inset-x-0 bg-gradient-to-t from-black/70 to-transparent p-2">
              <p className="text-white text-xs font-semibold">{t.package}</p>
              <p className="text-white/70 text-[10px]">{t.occasion}</p>
            </div>
          </button>
        ))}
      </div>
      <div className="mt-3 text-center">
        <p className="text-xs text-[#94a3b8]">Want to see YOUR room decorated? Upload a photo below for a custom AI preview</p>
      </div>
    </div>
  );
};
